import { useT } from '../../../../i18n';
import { useGoiYCauHoi } from '../../hooks/useHoi';

const NUT_CAU =
  'rounded-full border border-default px-3 py-1 text-start text-xs text-content-secondary ' +
  'transition hover:border-primary-600 hover:bg-primary-50 hover:text-primary-700';

/**
 * Câu hỏi gợi ý — bấm là hỏi luôn. Là NÚT chứ không phải chữ: một danh sách chỉ để đọc bắt người dùng gõ lại gần đúng
 * — đổi một hai từ, mất đúng chỗ làm câu ấy trả lời được.
 */
export function CauHoiTiep({ ds, nhan, onChon }: { ds: string[]; nhan: string; onChon: (q: string) => void }) {
  return (
    <div className="pt-1">
      <p className="mb-1.5 text-xs text-content-muted">{nhan}</p>
      <div className="flex flex-wrap gap-1.5">
        {ds.map((q, i) => (
          <button key={i} type="button" onClick={() => onChon(q)} className={NUT_CAU}>
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}

/** Bao nhiêu câu bày ra màn trống. Nhiều hơn thì nó thành một danh sách phải đọc. */
const SO_CAU = 4;

/** Câu mẫu cho màn trống, sinh từ nguồn đang cắm — xem `useGoiYCauHoi`. */
export function GoiY({ sourceId, onPick, disabled }: { sourceId: string; onPick: (q: string) => void; disabled: boolean }) {
  const { t } = useT();
  const goiY = useGoiYCauHoi(sourceId, !disabled);
  if (disabled) return null;
  const ds = (goiY.data ?? []).slice(0, SO_CAU);
  // Rỗng thì NÓI ĐƯỜNG ĐI, không im: việc cần làm chỉ là đi chốt danh sách câu hỏi.
  if (!ds.length) {
    if (goiY.isLoading) return null;
    return <p className="pt-1 text-xs leading-relaxed text-content-muted">{t('troLyAiHoi.goiYChuaCo')}</p>;
  }
  return (
    <div className="flex flex-wrap justify-center gap-1.5 pt-1">
      {ds.map((c) => (
        <button key={c} type="button" onClick={() => onPick(c)} className={NUT_CAU}>
          {c}
        </button>
      ))}
    </div>
  );
}
